import { Check, CheckCircle, XCircle } from "lucide-react";
import type { CopyFeedbackState } from "../hooks/useCopyFeedback";
import { cn } from "./ui/utils";

interface CopyFeedbackIndicatorProps {
  feedback: CopyFeedbackState | null;
  showOverlay?: boolean;
  className?: string;
}

export function CopyFeedbackIndicator({
  feedback,
  showOverlay = true,
  className,
}: CopyFeedbackIndicatorProps) {
  if (!feedback) {
    return null;
  }

  const isSuccess = feedback.status === "success";

  return (
    <>
      {showOverlay && isSuccess && (
        <div className="pointer-events-none fixed inset-x-0 top-24 z-30 flex justify-center">
          <div className="relative h-12 w-12">
            <span className="absolute inset-0 rounded-full bg-emerald-400/40 animate-ping" />
            <div className="relative flex h-12 w-12 items-center justify-center rounded-full bg-emerald-500 text-white shadow-xl">
              <Check className="h-5 w-5" />
            </div>
          </div>
        </div>
      )}
      <div className={cn("px-4 mt-3", className)}>
        <div
          role="status"
          aria-live="polite"
          className={cn(
            "flex items-center gap-2 rounded-2xl px-4 py-2 text-sm font-medium shadow-lg ring-1",
            isSuccess
              ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
              : "bg-destructive/10 text-destructive ring-destructive/30",
          )}
        >
          {isSuccess ? (
            <CheckCircle className="h-4 w-4" />
          ) : (
            <XCircle className="h-4 w-4" />
          )}
          <span>{feedback.message}</span>
        </div>
      </div>
    </>
  );
}

export default CopyFeedbackIndicator;

